import { prop, propObject, required } from "@rxweb/reactive-form-validators";
import { Resource } from "src/app/core/jsonapi/resource";
import { Client } from "../../clients/_types/client";

export class CaseMode extends Resource {
    public override type = 'caseModes';

    @prop()
    public code!: string;
    
    @prop()
    @required()
    public name!: string;

}